export default {
    set_wait_auth: (state, is_wait) => state.wait_auth = is_wait,
    set_userdata: (state, userdata) => state.userdata = userdata,
    set_token: (state, token) => {
        console.log("set_token", token)
        state.token = token
        if (token)
            localStorage.setItem("auth_token", token)
        else
            localStorage.removeItem("auth_token")
    },
}